import React from "react";

export default function ExpaSummary() {
  return (
    <>
      <div className="py-2">
        <ul className="pl-6 list-disc">
          <li>
            Revamped and extended a social commerce platform that integrates
            with Facebook API and enables SME users to sell products via
            Facebook Messenger.
          </li>
          <li>
            Built a website embeddable live chat plugin that works seemlessly by
            including link in the website and allows businesses to chat with
            customers in real-time.
          </li>
          <li>
            Built <i>an analytics solution</i> for the social commerce platform
            to provide businesses with insights into their storefronts.
          </li>
          <li>
            Implemented <i>AI driven automated customer replies</i> and enabled
            businesses to iteratively improve models using real conversation
            data.
          </li>
          <li>
            Built <i>the AI management platform</i> which allows businesses to
            deploy their own models instantly on the dashboard, and
            automatically scales those models depending on the usage.
          </li>
          <li>
            Implemented Event-Driven Architecture for storing user activity
            logs.
          </li>
        </ul>
      </div>
    </>
  );
}
